import { render } from "./Categories.vue?vue&type=template&id=f5e0f66c&scoped=true"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"

import "./Categories.vue?vue&type=style&index=0&id=f5e0f66c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5e0f66c"]])

export default __exports__